import {
  sortByTimestamp,
  dateToTimestamp,
} from "@intelligentlilli/lilli-utils";

export const extractDailyData = (countKey, dailyResults, from, to) => {
  if (!dailyResults || !countKey) return [];
  return sortByTimestamp(
    dailyResults
      ?.map((day) => ({
        ...day,
        ts: dateToTimestamp(day?.date),
        value: day?.dailyData?.[countKey],
        expectedMin: day?.dailyData?.expectedMin,
        expectedMax: day?.dailyData?.expectedMax,
        dayRating: day?.dayRating,
        date: day?.date,
      }))
      .filter(({ ts }) => ts >= from && ts <= to) || []
  );
};
